/**
 * BubbleChartEditor
 *
 * Property editor for bubble chart configuration
 */

import React from 'react';
import { ChartBaseEditor, type ChartBaseConfig } from './ChartBaseEditor';
import { TextPropertyEditor } from '../../BaseEditors/TextPropertyEditor';
import { NumberPropertyEditor } from '../../BaseEditors/NumberPropertyEditor';

export interface BubbleChartEditorProps {
  config: Partial<ChartBaseConfig & {
    xAxisKey?: string;
    yAxisKey?: string;
    sizeKey?: string;
    maxBubbleSize?: number;
  }>;
  onChange: (config: Partial<ChartBaseConfig>) => void;
}

export const BubbleChartEditor: React.FC<BubbleChartEditorProps> = ({ config, onChange }) => {
  return (
    <ChartBaseEditor config={config} onChange={onChange} chartType="Bubble Chart" showAxes>
      <div className="chart-editor__section">
        <h3 className="chart-editor__section-title">Bubble Chart Options</h3>

        <TextPropertyEditor
          label="X Axis Data Key"
          value={(config.xAxisKey as string) || 'x'}
          onChange={(xAxisKey) => onChange({ ...config, xAxisKey })}
          required
        />

        <TextPropertyEditor
          label="Y Axis Data Key"
          value={(config.yAxisKey as string) || 'y'}
          onChange={(yAxisKey) => onChange({ ...config, yAxisKey })}
          required
        />

        <TextPropertyEditor
          label="Size Data Key"
          value={(config.sizeKey as string) || 'size'}
          onChange={(sizeKey) => onChange({ ...config, sizeKey })}
          helpText="Property for bubble size"
          required
        />

        <NumberPropertyEditor
          label="Max Bubble Size"
          value={(config.maxBubbleSize as number) || 80}
          onChange={(maxBubbleSize) => onChange({ ...config, maxBubbleSize })}
          min={20}
          max={200}
          step={10}
          suffix="px"
        />
      </div>
    </ChartBaseEditor>
  );
};

BubbleChartEditor.displayName = 'BubbleChartEditor';
